/* eslint-disable react/forbid-component-props */
import classNames from 'classnames';
import React from 'react';

import withCondition from '@commons/withCondition';

import commonStyles from '@css/outline.scss';

import { isGridRowCellAlignmentEnabled } from '@services/featureFlags';

import styles from './row.scss';

function mainContainerStyles({ containerStyles, hasBorderStyle, hasHoverStyle }) {
  return classNames(styles.row, containerStyles, {
    [commonStyles.hasBorder]: hasBorderStyle,
    [commonStyles.hasHover]: hasHoverStyle,
    [styles.isGridRowCellAlignmentEnabled]: isGridRowCellAlignmentEnabled()
  });
}

interface RowProps {
  ariaHidden?: boolean;
  ariaId?: string;
  ariaLabel?: string;
  ariaLabelledBy?: string;
  ariaRole?: string;
  children?: React.ReactNode;
  containerElement?: string;
  containerStyles?: string;
  hasBorderStyle?: boolean;
  hasHoverStyle?: boolean;
  tabIndex?: number;
}

export default function Row({
  ariaHidden,
  ariaId,
  ariaLabel,
  ariaLabelledBy,
  ariaRole,
  children,
  containerElement = 'div',
  containerStyles,
  hasBorderStyle,
  hasHoverStyle,
  tabIndex
}: RowProps) {
  const rowContainerStyles = mainContainerStyles({
    containerStyles,
    hasBorderStyle,
    hasHoverStyle
  });
  const Container = containerElement;
  return (
    <Container
      id={ariaId}
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      className={rowContainerStyles}
      role={ariaRole}
      tabIndex={tabIndex}>
      {children}
    </Container>
  );
}

export const ConditionedRow = withCondition(Row);
